import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectDataSettingDefault, selectLoadingDefault } from './store/slice'
import { covertDataAgeById, loadingAge } from './store/sliceBusinessAge'
import { loadingSize } from './store/sliceBusinessSize'
import {
  convertDataIndustrySelectById,
  loadingIndustry,
} from './store/sliceIndustry'
import {
  covertDataPortById,
  loadingPortfolio,
  selectDataPortfolioAll,
} from './store/slicePortfolio'
import { covertDataProvinceById, loadingProvince } from './store/sliceProvince'
import {
  coverDataScoreLevelById,
  loadingScoreLevel,
} from './store/sliceScoreLevel'
import {
  getCompanies,
  getFilteredCompaniesBusinessAge,
  getFilteredCompaniesBusinessSize,
  getFilteredScoreRange,
  getProvinceVietNamese,
  getSearchPortfolioAllInSetting,
  getVSIC,
} from './store/thunk'

export const useCallApi = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectDataSettingDefault)
  const allPortId = useSelector(selectDataPortfolioAll)

  const isLoadingScore = useSelector(loadingScoreLevel)
  const isLoadingProvince = useSelector(loadingProvince)
  const isLoadingPort = useSelector(loadingPortfolio('getAllPort'))
  const isLoadingIndustry = useSelector(loadingIndustry)
  const isLoadingSize = useSelector(loadingSize)
  const isLoadingAge = useSelector(loadingAge)
  const isLoadingDefault = useSelector(selectLoadingDefault)

  const isLoading =
    isLoadingScore ||
    isLoadingProvince ||
    isLoadingPort ||
    isLoadingIndustry ||
    isLoadingSize ||
    isLoadingAge ||
    isLoadingDefault

  const {
    portfolioId,
    bussinessAgeId,
    excludeId,
    industryId,
    provinceId,
    scoreLevelObj,
  } = data

  useEffect(() => {
    dispatch(getVSIC())
    dispatch(getProvinceVietNamese())
    dispatch(getFilteredCompaniesBusinessSize())
    dispatch(getFilteredCompaniesBusinessAge())
    dispatch(getFilteredScoreRange())
    dispatch(getSearchPortfolioAllInSetting())
  }, [locale])

  useEffect(() => {
    if (isLoading) return

    portfolioId.length
      ? dispatch(covertDataPortById(portfolioId))
      : dispatch(covertDataPortById(allPortId.map((item) => item.value)))
    dispatch(covertDataProvinceById(provinceId))
    dispatch(convertDataIndustrySelectById(industryId))
    dispatch(covertDataAgeById(bussinessAgeId))

    excludeId.length &&
      dispatch(
        getCompanies({
          page: 1,
          pageSize: excludeId.length,
          organizationIds: excludeId,
        }),
      )

    Object.keys(scoreLevelObj).length &&
      dispatch(coverDataScoreLevelById(scoreLevelObj))
  }, [isLoading, data])

  return { isLoading, isLoadingPort }
}
